import React, { memo, useEffect, useState } from 'react';
import { Stack, CircularProgress } from 'investira.react.components';
import services from '../../../services';
import { InlineInfo } from '../../molecules';

/**
 * Renderiza o componente EmpresaSetores.
 *
 * @param {Object} props - Propriedades do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const EmpresaSetores = memo(props => {
  const [setores, setSetores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  console.log('props', props);

  useEffect(() => {
    setIsLoading(true);
    services.pessoas.setores(
      { pessoa_id: props.pessoaId },
      rRes => {
        setSetores(rRes.data);
      },
      rErr => {
        console.log(rErr);
      },
      () => {
        setIsLoading(false);
      }
    );
  }, [props.pessoaId]);

  if (isLoading) {
    return (
      <Stack justifyContent="center" alignItems="center" flexGrow={1} sx={{ py: 2 }}>
        <CircularProgress size={24} />
      </Stack>
    );
  }

  return (
    <Stack direction="column" spacing={2}>
      {setores.map((setor, index) => {
        return (
          <InlineInfo
            key={index}
            label={`${setor.top_setor} (CNAE: ${setor.setor_id})`}
            value={setor.setor}
            searchProps={{
              ...props.searchProps,
              path: '/empresas',
              search: {
                top_setor_id: setor.top_setor_id,
                setor_id: setor.setor_id
              }
            }}
          />
        );
      })}
    </Stack>
  );
});

export default EmpresaSetores;
